import { DateTime } from "luxon";

const isToday = (date: DateTime): boolean => {
  return date.hasSame(DateTime.local(), "day");
};

const isInTheFuture = (date: DateTime): boolean => {
  return date.diffNow("days").toObject().days > 0;
};

const isLessThanSevenDaysAgo = (date: DateTime): boolean => {
  const today = DateTime.local();
  return today.diff(date, "days").toObject().days < 7;
};

const daysAgo = (date: DateTime): number => {
  const today = DateTime.local();
  return Math.floor(today.diff(date, "days").toObject().days);
};

export const getHumanizedFromToday = (date: DateTime): string => {
  const dt = date;
  if (isInTheFuture(dt)) {
    const days = daysAgo(dt);
    if (days === -1) {
      return `${Math.abs(days)} day from today`;
    }
    return `${Math.abs(days)} days from today`;
  }

  if (isToday(dt)) {
    return "Today";
  }

  if (isLessThanSevenDaysAgo(dt)) {
    const days = daysAgo(dt);
    if (days === 1) {
      return `${days} day ago`;
    }
    return `${days} days ago`;
  }

  return dt.toLocaleString(DateTime.DATE_MED);
};
